// extracted by mini-css-extract-plugin
export default {"wrapper":"Va","body":"Wa","heading":"Xa","button":"Ya","blinking":"Za"};